

import { Button, Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useTaxesV2 } from "../../hooks/useTaxsV2";
import { ExceptionIcon } from "../../styles/icons/ExceptionIcon";
import { PlusIcon } from "../../styles/icons/PlusIcon";
import { adjustNewResponse, adjustResponse, adjustResponseRepasse, invertRatesStructure } from "./utils/functions";
import { ReviewModal } from "./modal/reviewModal";
import { useTaxes } from "../../contexts/TaxV2Context";

interface History {
    setLimit: React.Dispatch<React.SetStateAction<number>>;
    limit: number;
    setObservationText: React.Dispatch<React.SetStateAction<string>>

}

export function ChangeHistoriySection({ setLimit, limit, setObservationText }: History) {
    const [historySigned, setHistorySigned] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const { getUrlSigned } = useTaxesV2();
    const [, setIsDataloaded] = useState<boolean>(false)
    const [organizateRateReviewPixNew, setOrganizateRateReviewPixNew] = useState({})
    const [organizateRateReviewPixOld, setOrganizateRateReviewPixOld] = useState({})
    const [organizateRateReviewNewCard, setOrganizateRateReviewNewCard] = useState({})
    const [organizateRateReviewOldCard, setOrganizateRateReviewOldCard] = useState({})
    const [organizateRateReviewBankSlipOld, setOrganizateRateReviewBankSlipOld] = useState({})
    const [organizateRateReviewBankSlipNew, setOrganizateRateReviewBankSlipNew] = useState({})
    const [organizateRateReviewCreditCardOld, setOrganizateRateReviewCreditCardOld] = useState({})
    const [organizateRateReviewCreditCardNew, setOrganizateRateReviewCreditCardNew] = useState({})
    const [organizateRateOld, setOrganizateRateOld] = useState();
    const [organizateRateNew, setOrganizateRateNew] = useState();
    const {
        history
    } = useTaxes();




    const getHistory = async (id) => {
        try {
            const historyResponse = await getUrlSigned(id);
            if (!historyResponse?.signedUrl) {
                throw new Error("Signed URL is undefined");
            }
            setHistorySigned(historyResponse.signedUrl);
            setDescription(historyResponse?.description)
        } catch (error) {
            console.error("Error fetching history:", error);
        }
    };



    function buildComponent(data, origin) {
        const organizedRatesOld = adjustResponse(data.oldRates, origin)
        const organizedRatesNew = adjustResponse(data.newRates, origin)
        const organizedRatesDayOld = adjustResponseRepasse(data.oldRates, origin)
        const organizedRatesDayNew = adjustResponseRepasse(data.newRates, origin)
        if (origin === "PIX") {
            setOrganizateRateReviewPixNew({ organizedRatesNew, organizedRatesDayNew });
            setOrganizateRateReviewPixOld({ organizedRatesOld, organizedRatesDayOld });
        }
        if (origin === "BANK_SLIP") {
            setOrganizateRateReviewBankSlipNew({ organizedRatesNew, organizedRatesDayNew });
            setOrganizateRateReviewBankSlipOld({ organizedRatesOld, organizedRatesDayOld });
        }
        if (origin === "CREDIT_CARD_EARLY_SELLER") {
            setOrganizateRateReviewCreditCardNew({ organizedRatesNew, organizedRatesDayNew });
            setOrganizateRateReviewCreditCardOld({ organizedRatesOld, organizedRatesDayOld });
            setOrganizateRateReviewNewCard(invertRatesStructure(adjustResponse(data.newRates, "CREDIT_CARD_EARLY_SELLER")))
            setOrganizateRateReviewOldCard(invertRatesStructure(adjustResponse(data.oldRates, "CREDIT_CARD_EARLY_SELLER")))
        }
    }


    useEffect(() => {
        const fetchData = async () => {
            if (!historySigned) {
                console.warn('Signed URL ainda não está disponível.');
                return;
            }

            try {
                const response = await fetch(historySigned, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();

                if (data) {
                    buildComponent(data, "PIX")
                    buildComponent(data, "BANK_SLIP")
                    buildComponent(data, "CREDIT_CARD_EARLY_SELLER")
                    setOrganizateRateNew(adjustNewResponse(data?.newRates))
                    setOrganizateRateOld(adjustNewResponse(data?.oldRates))
                }

            } catch (error) {
                console.error('Erro ao buscar dados:', error);
            } finally {
                setIsDataloaded(true)
            }
        };

        fetchData();
    }, [historySigned]);



    function getDateCreated(date, type: "date" | "hour") {
        const newDate = new Date(date);
        const day = newDate.getDate();
        const month = newDate.getMonth() + 1;
        const year = newDate.getFullYear();
        const hours = newDate.getHours();
        const minutes = newDate.getMinutes();
        const formattedDay = day.toString().padStart(2, '0');
        const formattedMonth = month.toString().padStart(2, '0');
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        if (type === "date") {
            return ` ${formattedDay}/${formattedMonth}/${year}`
        }
        if (type === "hour") {
            return ` ${formattedHours}h${formattedMinutes}`
        }
    }

    return (
        <Flex
            flexDirection="column"
            gap="38px"
        >
            <Flex gap="8px" alignItems="center">
                <ExceptionIcon />
                <Text
                    fontSize="20px"
                    fontFamily="Hero New"
                    fontWeight="600"
                >
                    Histórico de alterações
                </Text>
            </Flex>


            {history ? history?.content?.map((item, index) => {

                return (
                    <Flex
                        flexDirection="column"
                        gap="4px"
                        key={index}
                    >
                        <Text
                            fontSize="12px"
                            fontFamily='Hero New'
                            fontWeight="400"
                            color="rgba(138, 148, 168, 1)"
                        >
                            {getDateCreated(item?.createdAt, "date")} -{getDateCreated(item?.createdAt, "hour")} - {item?.createdBy}
                        </Text>
                        <Text>
                            {item?.description}
                        </Text>
                        <Flex
                            gap="10px"
                            alignItems="center"
                            onClick={() => {
                                getHistory(item?.id);
                            }}
                        >
                            <ReviewModal
                                observationText={description}
                                setObservationText={setObservationText}
                                organizateRateOld={organizateRateOld}
                                organizateRateNew={organizateRateNew}
                                isHistory={true}
                                createdDate={`${getDateCreated(item?.createdAt, "date")} -${getDateCreated(item?.createdAt, "hour")} - ${item?.createdBy}`}
                                creditCardOldRates={organizateRateReviewOldCard}
                                creditCardNewRates={organizateRateReviewNewCard}
                                organizateRateReviewPixNew={organizateRateReviewPixNew}
                                organizateRateReviewPixOld={organizateRateReviewPixOld}
                                organizateRateReviewBankSlipOld={organizateRateReviewBankSlipOld}
                                organizateRateReviewBankSlipNew={organizateRateReviewBankSlipNew}
                                organizateRateReviewCreditCardOld={organizateRateReviewCreditCardOld}
                                organizateRateReviewCreditCardNew={organizateRateReviewCreditCardNew}
                            />
                        </Flex>
                    </Flex>
                )
            }) :
                <Flex fontSize="12px"
                    fontFamily='Hero New'
                    fontWeight="600"
                    color="rgba(138, 148, 168, 1)"
                    p="0 20px"
                    >
                    <Text>
                        Sem histórico
                    </Text>
                </Flex>
            }

            <Button
                alignItems="center"
                backgroundColor="white"
                _hover={{ backgroundColor: "none" }}
                isDisabled={history?.size >= history?.totalElements || !history}
                cursor="pointer"
                w="101px"
                h="32px"
                onClick={() => setLimit(limit + 5)}
            >
                <Flex
                    gap="8px"
                >

                    <PlusIcon />
                    <Text
                    >
                        Ver mais
                    </Text>

                </Flex>
            </Button>
        </Flex>

    )

}


